module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_26-056198253968ced221fca2a01b0fb955.jpg";